module.exports = __webpack_public_path__ + "static/media/logo-black.d8289abd.svg";